"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=require("./index23.js");var t=r.functionUncurryThis,o=t({}.isPrototypeOf);exports.objectIsPrototypeOf=o;
